import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['badge']
  static values = { currentPersonId: Number, cycleId: Number }

  connect() {
    document.addEventListener('reporting-cycle:comment-added', this.handleCommentAdded)
  }

  disconnect() {
    document.removeEventListener('reporting-cycle:comment-added', this.handleCommentAdded)
  }

  handleCommentAdded = event => {
    const authorId = event.detail?.authorId
    const cycleId = event.detail?.cycleId

    if (cycleId === this.cycleIdValue && authorId && authorId !== this.currentPersonIdValue) {
      this.badgeTarget.classList.remove('d-none')
    }
  }

  hideBadge() {
    if (this.hasBadgeTarget) {
      this.badgeTarget.classList.add('d-none')
    }
  }
}
